import React from "react";
import { connect } from "react-redux";
import { getArticle, editArticle } from "../../actions/freelancer";
import { USER_ROLES } from "../../utils/constant";
import { getRole, capitalize } from "../../utils/tools";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Button,
  FormGroup,
  UncontrolledAlert,
  Modal,
} from "reactstrap";
import ReactCrop from "react-image-crop";
import TextEditor from "../../components/Commons/TextEditor";
import ArticleForm from "../../components/freelancer/ArticleForm";
import OverlayLoading from "../../components/Commons/OverlayLoading.jsx";
import moment from "moment";
import { DOMAIN } from "../../utils/constant";
import { Link } from "react-router-dom";
// Require Editor JS files.
import "froala-editor/js/froala_editor.pkgd.min.js";

// Require Editor CSS files.
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";

// Require Font Awesome.
import "font-awesome/css/font-awesome.css";

import FroalaEditor from "react-froala-wysiwyg";

// Include special components if required.
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
// import FroalaEditorA from 'react-froala-wysiwyg/FroalaEditorA';
// import FroalaEditorButton from 'react-froala-wysiwyg/FroalaEditorButton';
// import FroalaEditorImg from 'react-froala-wysiwyg/FroalaEditorImg';
// import FroalaEditorInput from 'react-froala-wysiwyg/FroalaEditorInput';
import twitter from "../../assets/img/icons/common/twitter.svg";
import wechat from "../../assets/img/icons/common/wechat.svg";
import weibo from "../../assets/img/icons/common/weibo.svg";
import facebook from "../../assets/img/icons/common/facebook.svg";
import IconUser from "../../components/Icon/User.jsx";
class AricleEditPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      article: {},
      crop: {
        unit: "%",
        width: 30,
        aspect: 16 / 10,
      },
      src: null,
      croppedImageUrl: null,
      editable: false,
      previewModal: false,
    };
    this.onTextInputChange = this.onTextInputChange.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.submitArticle = this.submitArticle.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    this.id = id;
    this.props.getArticle(id);
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.freelancer.selectedArticle !==
      this.props.freelancer.selectedArticle
    ) {
      let article = newProps.freelancer.selectedArticle;
      if (article.categories) {
        article.category_ids = [];
        for (let i = 0; i < article.categories.length; i++) {
          article.category_ids.push(article.categories[i].id);
        }
      }
      if (article.cover_image) {
        this.setState({ croppedImageUrl: DOMAIN + article.cover_image });
      }

      this.setState({
        article: article,
      });
    }
  }

  toggleModal = (state) => {
    this.setState({
      previewModal: !this.state.previewModal,
    });
  };

  onTextInputChange(e, target) {
    let value = e.target.value;

    let article = this.state.article;
    article[target] = value;
    this.setState({
      article: article,
    });
  }

  handleCheckBoxChange(e) {
    const { checked, value } = e.target;
    let article = this.state.article;
    if (checked && article.category_ids.indexOf(value) === -1) {
      article.category_ids.push(parseInt(value));
    } else {
      article.category_ids = article.category_ids.filter(
        (id) => id !== parseInt(value)
      );
    }
    this.setState({
      article: article,
    });
  }

  formatTime(dateString) {
    return moment(dateString).format("YYYY-MM-DD");
  }

  submitArticle() {
    let { file, article } = this.state;
    const post_id = article.id;
    const category_ids = article.category_ids;
    const title = article.title;
    const body = article.body;
    const status = article.status;
    const cover_img = file;
    const author_name = article.author;
    const published_at = article.published_at;
    this.props.editArticle({
      post_id,
      category_ids,
      title,
      body,
      status,
      cover_img,
      author_name,
      published_at,
    });
  }

  render() {
    const { crop, croppedImageUrl, src, editable } = this.state;
    let {
      getArticleRequest,
      errorMsg,
      errors,
      editArticleRequest,
      selectedArticle,
    } = this.props.freelancer;
    const coverImg = this.state.croppedImageUrl
      ? this.state.croppedImageUrl
      : DOMAIN + "resources/cloud-upload-light.png";
    var sectionStyle = {
      width: "100%",
      paddingBottom: "60%",
      height: "0",
      border: "1px solid #ccc",
      borderRadius: "4px",
      background:
        'url("' +
        coverImg +
        '") center center / cover no-repeat rgb(255, 255, 255)',
    };
    var fileInputStyle = {
      position: "absolute",
      opacity: 0,
      right: 0,
      top: 0,
      bottom: 0,
      left: 0,
      filter: "alpha(opacity = 0)",
      cursor: "pointer",
    };
    var uploadBtnWrapper = {
      position: "relative",
      display: "block",
      borderRadius: "6px",
      cursor: "pointer",
    };

    return (
      <Container className="mt-4" fluid>
        <Card className="card-frame">
          <CardHeader className="border-0">
            <div className="d-flex align-items-center justify-content-between">
              <div>編輯文章</div>
              <div className="d-flex align-items-center">
                <Button
                  color="secondary"
                  tag={Link}
                  to={"/dash/admin/other-articles"}
                >
                  返回
                </Button>
              </div>
            </div>
          </CardHeader>
          <OverlayLoading loading={getArticleRequest}>
            <CardBody className="row">
              <div className="col-lg-8 px-4">
                <FroalaEditorView
                  model={selectedArticle ? selectedArticle.body : ""}
                />
              </div>
              <div className="col-lg-4 px-4">
                {errorMsg && (
                  <UncontrolledAlert color="danger" fade={false}>
                    <span className="alert-inner--text">{errorMsg}</span>
                  </UncontrolledAlert>
                )}
                <ArticleForm
                  data={this.state.article}
                  onTextInputChange={this.onTextInputChange}
                  handleCheckBoxChange={this.handleCheckBoxChange}
                  submitArticle={this.submitArticle}
                  loading={editArticleRequest}
                  togglePreview={this.toggleModal}
                />
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="example-date-input"
                  >
                    封面圖片
                  </label>
                  {!editable && <div style={sectionStyle}></div>}
                </FormGroup>

                <p>
                  上次更新：{this.formatTime(this.state.article.updated_at)}
                </p>
                <p>瀏覽次數：{this.state.article.views}</p>
                <p>
                  編輯：
                  {this.state.article.editor
                    ? this.state.article.editor.name
                    : "N/A"}
                </p>
              </div>
            </CardBody>
          </OverlayLoading>
        </Card>
        <Modal
          className="modal-dialog-centered modal-lg"
          isOpen={this.state.previewModal}
          toggle={() => this.toggleModal()}
        >
          <div className="modal-header">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal()}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <h1>{this.state.article ? this.state.article.title : ""}</h1>
            <p className="d-flex align-items-center">
              {this.state.article
                ? moment(this.state.article.published_at).format("YYYY-MM-DD")
                : ""}
              &nbsp;&nbsp;&nbsp;&nbsp; <IconUser className="size-4" />
              &nbsp;{this.state.article ? this.state.article.author : ""}{" "}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <img src={weibo} />
              &nbsp;
              <img src={wechat} />
              &nbsp;
              <img src={twitter} />
              &nbsp;
              <img src={facebook} />
            </p>
            <hr className="my-3" />
            {!editable && <div className="my-4" style={sectionStyle}></div>}
            <FroalaEditorView
              model={this.state.article ? this.state.article.body : ""}
            />
            <p>
              分享至 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <img src={weibo} />
              &nbsp;
              <img src={wechat} />
              &nbsp;
              <img src={twitter} />
              &nbsp;
              <img src={facebook} />
            </p>
          </div>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    freelancer: state.freelancer,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getArticle: (params) => dispatch(getArticle(params)),
    editArticle: (params) => dispatch(editArticle(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AricleEditPage);
